"use client";
import useCart from "@/src/hooks/useCart";
import { formatPrice } from "@/src/utils/formatPriceDolar";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Input, Modal, ModalBody } from "reactstrap";
import { Swiper as SwiperType } from "swiper";
import "swiper/css";

import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const isValidImageUrl = (url: string): boolean => {
  try {
    return url.startsWith("http://") || url.startsWith("https://");
  } catch {
    return false;
  }
};

export default function ProductBox({ item, hoverEffect }: ProductBoxProps) {
  const {
    addToCart,
    cart,
    increaseQuantityF,
    decreaseQuantityF,
    removeFromCart,
  } = useCart();

  const router = useRouter();
  const [modal, setModal] = useState(false);
  const [quantity, setQuantity] = useState(0);

  const titleProps = item.name
    .replace(/\s+/g, "_")
    .replace(/,/g, "_")
    .replace(/\//g, "_")
    .replace(/\(/g, "_")
    .replace(/\+/g, "_")
    .replace(/\*/g, "_")
    .replace(/\)/g, "_")
    .replace(/:/g, "_")
    .replace(/'/g, "_")
    .replace("%", "")
    .replace(/-/g, "_")
    .replace(/__/g, "_")
    .toLowerCase();
  const [openQty, setOpenQty] = useState(false);

  const minusQty = (itemId: number) => {
    if (quantity < 1) {
      setOpenQty(false);
      removeFromCart(itemId);
    } else {
      decreaseQuantityF(itemId);
      setQuantity(quantity - 1);
      //quitar del carrito
    }
  };

  const plusQty = (itemId: number) => {
    const itemFind = cart.items.find((item) => item.id_product === itemId);
    if (itemFind) {
      if (item.stock != 0 && quantity < item.stock) {
        if (item.price > 0) {
          increaseQuantityF(itemId);
          setQuantity(quantity + 1);
          setOpenQty(true);
        } else {
          toast.error("El producto debe tener un precio");
        }
      } else {
        toast.error("El producto tinen un stock limitado");
      }
    } else {
      if (item.stock != 0 && quantity < item.stock) {
        if (item.price > 0) {
          addToCart(item);
        } else {
          toast.error("El producto debe tener un precio");
        }
      } else {
        toast.error("El producto tinen un stock limitado");
      }
    }
  };

  const QuickView = () => {
    setModal(!modal);
  };

  const clickProductDetail = () => {
    router.push(`/producto/${item.id_product}/${titleProps}`);
  };

  const findItemQuantity = (id: number) => {
    const item = cart.items.find((item) => item.id_product === id);
    return item ? item.quantity : 0;
  };

  useEffect(() => {
    setQuantity(findItemQuantity(item.id_product));
    const itemQ = findItemQuantity(item.id_product);
    if (itemQ > 0) {
      setOpenQty(true);
    } else {
      setOpenQty(false);
    }
  }, [cart.items]);
  const [thumbsSwiperS, setThumbsSwiper] = useState<SwiperType | undefined>();
  const changeQty = (e) => {
    setQuantity(parseInt(e.target.value));
  };
  const handleClick = async () => {
    try {
      const datalog = {
        id_product: item.id_product,
        productName: item.name,
        price: item.price,
      };
      const res = await fetch("/api/log-click", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datalog),
      });

      const data = await res.json();
    } catch (error) {
      console.error("Error al registrar clic:", error);
    }
  };

  const generateWhatsAppLink = (): string => {
    const baseURL = "https://wa.me/";
    const message = `Hola, estoy interesado en obtener más información sobre el producto: \n\n- *ID producto:* ${
      item.id_product
    } ${
      item.code_in ? `\n- *Código interno:* ${item.code_in} ` : ""
    }\n\n- *Nombre:* ${item.name} \n\n¿Podrían ayudarme?`;
    const encodedMessage = `?text=${encodeURIComponent(message)}`;
    return `${baseURL}${process.env.NEXT_WHATSAPP_NUMBER}${encodedMessage}`;
  };

  return (
    <>
      <div className="product-box">
        <div className="product-imgbox">
          <div className="product-front" onClick={clickProductDetail}>
            <div>
              <Image
                src={
                  item?.images?.[0]?.src && isValidImageUrl(item.images[0].src)
                    ? item.images[0].src
                    : `${process.env.BASE_IMAGE_URL}`
                }
                alt={item?.name}
                className="img-card"
                width={400}
                height={350}
                onError={(e) => {
                  e.currentTarget.src = `${process.env.BASE_IMAGE_URL}`;
                }}
              />
            </div>
          </div>

          <div className={`product-icon ${hoverEffect}`}>
            {/*  <button
              onClick={() => {
                plusQty(item.id_product);
              }}
            >
              <i className="ti-bag"></i>
            </button> */}

            <a href="#" title="Quick View" onClick={() => QuickView()}>
              <i className="ti-search"></i>
            </a>
          </div>
          {item.status_new && (
            <div className="new-label1">
              <div>Nuevo</div>
            </div>
          )}
          {item.stock == 0 ? <div className="on-sale3"> Sin Stock </div> : ""}
        </div>
        <div className="product-detail detail-inline">
          <div className="detail-title">
            <div className="detail-center">
              <Link href={`/producto/${item.id_product}/${titleProps}`}>
                <h6 className="price-title">
                  {item.name.length > 20
                    ? `${item.name.substring(0, 20)}...`
                    : item.name}
                </h6>
              </Link>
            </div>
            <div className="detail-right">
              {/*
              Precio tachado
              <div className="check-price">
                {selectedCurr.symbol}
                {(item.price * selectedCurr.value).toFixed(2)}{" "}
              </div> */}
              <div className="price">
                <div className="price">
                  C/IVA:{" "}
                  {formatPrice({
                    price: item.price,
                    currency: "USD",
                  })}
                </div>
              </div>
            </div>
            <div className="detail-left">
              <div className="  mt-1">
                <h6 className="price-title">
                  <div className="price">
                    {formatPrice({
                      price: item.price_tourist,
                      currency: "USD",
                    })}
                  </div>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="detail-buttom ">
          <div className={`detail-center ${openQty ? "d-none" : ""}`}>
            <Link
              href={generateWhatsAppLink()}
              onClick={handleClick}
              target="_blank"
              className={`btn btn-normal btn-outline btn-card `}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-whatsapp"
                viewBox="0 0 16 16"
                style={{ fontSize: "1.1rem", marginRight: "10px" }}
              >
                <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
              </svg>
              Consultar Por Whatsapp
            </Link>
          </div>
          {/* <div className={`detail-center  ${openQty ? "d-none" : ""}`}>
            <Button
              className={`btn btn-normal btn-outline btn-card `}
              onClick={() => {
                plusQty(item.id_product);
              }}
            >
              <i
                className="ti-shopping-cart"
                style={{ fontSize: "1.1rem", marginRight: "10px" }}
              ></i>
              Agregar al carrito
            </Button>
          </div> */}
          <div
            className={`qty-box cart_qty ${openQty == false ? "d-none" : ""}`}
          >
            <div className="input-group">
              <button
                type="button"
                className="btn quantity-left-minus"
                data-type="minus"
                data-field=""
                onClick={() => minusQty(item.id_product)}
              >
                <i className="fa fa-minus"></i>
              </button>
              <Input
                type="text"
                name="quantity"
                value={quantity < 0 ? 1 : findItemQuantity(item.id_product)}
                readOnly={true}
                className="form-control input-number qty-input"
                onChange={changeQty}
              />
              <button
                type="button"
                className="btn quantity-right-plus"
                data-type="plus"
                data-field=""
                onClick={() => plusQty(item.id_product)}
              >
                <i className="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="fade bd-example-modal-lg theme-modal show quick-view-modal p-4"
        isOpen={modal}
        toggle={() => setModal(!modal)}
        centered
        size="xl"
      >
        <ModalBody>
          <button
            type="button"
            className="close color-red"
            onClick={() => setModal(!modal)}
          >
            <span>&times;</span>
          </button>
          <div className="row">
            <div className="col-lg-6 col-xs-12 SlideProductView">
              <Swiper
                spaceBetween={50}
                thumbs={{ swiper: thumbsSwiperS }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
              >
                {item.images.length == 0 || item.images == undefined ? (
                  <>
                    <SwiperSlide>
                      <Image
                        src={`${process.env.BASE_IMAGE_URL}`}
                        alt="imagen"
                        width={600}
                        height={400}
                      />
                    </SwiperSlide>
                  </>
                ) : (
                  item.images.map((img: imagesType, i: number) => {
                    return (
                      <SwiperSlide key={i}>
                        <Image
                          src={img.src}
                          alt={img.alt}
                          width={600}
                          height={400}
                        />
                        {/*  <SwiperSlide className="imgContainerZoom">
                    <ZoomPreview target={target} image={img.src} />
                  </SwiperSlide> */}
                      </SwiperSlide>
                    );
                  })
                )}
              </Swiper>
              <Swiper
                spaceBetween={10}
                slidesPerView={3}
                onSwiper={setThumbsSwiper}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
                direction="horizontal"
              >
                {item &&
                  item.images.map((img: imagesType, i: number) => {
                    return (
                      <SwiperSlide key={i}>
                        <Image
                          src={img.src}
                          alt={img.alt}
                          className="img-fluid  image_zoom_cls-0"
                          width={250}
                          height={150}
                        />
                      </SwiperSlide>
                    );
                  })}
              </Swiper>
            </div>
            <div className="col-lg-6 rtl-text">
              <div className="product-right">
                <h2>{item?.name}</h2>

                <h4>
                  {formatPrice({
                    price: item.price_tourist,
                    currency: "USD",
                  })}
                </h4>
                <h4>
                  C/IVA{" "}
                  {formatPrice({
                    price: item.price,
                    currency: "USD",
                  })}
                </h4>
                {item.stock == 0 ? (
                  <span
                    className="instock-cls"
                    style={{
                      color: "red",
                      fontSize: "1.2rem",
                      width: "100%",
                      marginBottom: "1.3rem",
                    }}
                  >
                    Producto sin stock
                  </span>
                ) : item.stock <= 10 && item.stock > 1 ? (
                  <h4
                    style={{
                      color: "#D68317FF",
                      marginTop: "1rem",
                    }}
                  >
                    Ultimas {item.stock} unidades disponibles
                  </h4>
                ) : item.stock == 1 ? (
                  <>Ultima unidad disponible</>
                ) : (
                  <span
                    style={{
                      color: "white",
                      fontSize: "1rem",
                      width: "100%",
                      backgroundColor: "green",
                      marginBottom: "1.3rem",
                      padding: ".6rem",
                      borderRadius: "3rem",
                    }}
                  >
                    Disponible
                  </span>
                )}

                <div className="border-product">
                  <p>ID: {item?.id_product}</p>
                </div>
                <div className="product-description border-product">
                  <h6 className="product-title">Detalles del producto</h6>

                  <p>{item?.description}</p>

                  <div className="size-box">
                    <ul>
                      {/* {uniqueSize.map((size, i) => (
                        <li key={i}>
                          <a href="#" onClick={(e) => e.preventDefault()}>
                            {size}
                          </a>
                        </li>
                      ))} */}
                    </ul>
                  </div>
                  {/*  {stockState !== "InStock" ? (
                    <span className="instock-cls">{stockState}</span>
                  ) : (
                    ""
                  )} */}
                  {/* <h6 className={`product-title ${openQty ? "" : "d-none"}`}>
                    Cantidad
                  </h6>
                  <div className={`qty-box ${openQty ? "" : "d-none"}`}>
                    <div className="input-group">
                      <span className="input-group-prepend">
                        <button
                          type="button"
                          className="btn quantity-left-minus"
                          onClick={() => minusQty(item.id_product)}
                        >
                          <i className="ti-angle-left"></i>
                        </button>
                      </span>
                      <input
                        type="text"
                        name="quantity"
                        className="form-control input-number"
                        value={
                          quantity < 0 ? 1 : findItemQuantity(item.id_product)
                        }
                      />
                      <span className="input-group-prepend">
                        <button
                          type="button"
                          className="btn quantity-right-plus"
                          onClick={() => plusQty(item.id_product)}
                        >
                          <i className="ti-angle-right"></i>
                        </button>
                      </span>
                    </div>
                  </div> */}
                </div>
                <div className="product-buttons">
                  <Link
                    href={generateWhatsAppLink()}
                    target="_blank"
                    className={`btn btn-normal btn-outline btn-card `}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-whatsapp"
                      viewBox="0 0 16 16"
                      style={{ fontSize: "1.1rem", marginRight: "10px" }}
                    >
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                    </svg>
                    Consultar Por Whatsapp
                  </Link>
                  {/*   <a
                    href="#"
                    className="btn btn-normal btn-outline"
                    onClick={() => {
                      addToCart(item);
                      setOpenQty(true);

                     
                    }}
                  >
                    Agregar al carrito
                  </a> */}
                  <a
                    href="#"
                    className="btn btn-normal  btn-outline"
                    onClick={() => clickProductDetail()}
                  >
                    Ver detalles
                  </a>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
